import { skills } from "../data/skills";
const safeSkills = Array.isArray(skills) ? skills : [];

export default function Skills() {
  return (
    <section id="skills" className="bg-navy-950 section-padding">
      <div className="container-max">
        <div className="text-center mb-14">
          <span className="section-tag">What I Work With</span>
          <h2 className="section-title">Skills &amp; Technologies</h2>
          <p className="section-sub">
            My Tech Stack: Languages, frameworks, databases, and engineering practices I use to build reliable applications.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {safeSkills.map((group) => (
            <div key={group.category} className="card-glow">
              {/* Category header */}
              <div className="flex items-center gap-2 mb-5">
                <div className="w-2 h-2 rounded-full bg-cyan-400 flex-shrink-0" />
                <h3 className="font-bold text-cyan-400 text-xs tracking-widest uppercase">
                  {group.category}
                </h3>
              </div>

              {/* Skill pills with icons */}
              <div className="flex flex-wrap gap-2">
                {group.items.map((skill) => (
                  <span
                    key={skill.label}
                    className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-lg
                               bg-navy-900 border border-navy-700 text-slate-300
                               hover:border-cyan-500/50 hover:text-cyan-400 transition-colors cursor-default"
                  >
                    <span className="text-cyan-500/70 text-sm">{skill.icon}</span>
                    {skill.label}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}